import _styled from "../../../_snowpack/pkg/styled-components.js";
import React, { useRef } from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import isEmpty from '../../../_snowpack/pkg/lodash/isEmpty.js';
import { useOnClickOutside, useTenant, useLocalStorage } from '../../hooks/index.js';
import { screen } from '../../css/screen.js';
import SideBar from './sidebar/index.js';
import CompleteSignUp from './complete-signup/index.js';
const Wrapper = styled.div.withConfig({
  displayName: "layout__Wrapper",
  componentId: "sc-15stabf-0"
})(["overflow-x:hidden;"]);

var _StyledWrapper = styled(Wrapper).withConfig({
  displayName: "layout___StyledWrapper",
  componentId: "sc-15stabf-1"
})(["--sidebar-width:0px;@media only screen and (min-width:", "px){--sidebar-width:", ";}"], p => p._css, p => p._css2);

const Main = styled.main.withConfig({
  displayName: "layout__Main",
  componentId: "sc-15stabf-2"
})(["margin:0 0 0 50px;transform:translate3d(0,0,0);will-change:transform;transition:transform 0.5s cubic-bezier(0.41,0.03,0,0.96) 0s;width:calc(100% - var(--sidebar-width) - 50px);"]);

function Layout({
  children
}) {
  const sidebarRef = useRef();
  const {
    tenant,
    tenants
  } = useTenant();
  useOnClickOutside(sidebarRef, closeSideBar);
  const isInviteToken = window.location.pathname.startsWith('/get-access');
  const [lsPinnedSidebar, setLSPinnedSidebar] = useLocalStorage('crystallize:pinnedSidebar', 'closed');

  function toggleSideBar(event) {
    var _document$querySelect;

    event.stopPropagation();
    (_document$querySelect = document.querySelector('.sidebar')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.toggle('open');
  }

  function closeSideBar() {
    var _sidebarRef$current;

    if ((_sidebarRef$current = sidebarRef.current) !== null && _sidebarRef$current !== void 0 && _sidebarRef$current.classList.contains('open')) {
      var _sidebarRef$current2, _sidebarRef$current3;

      const caret = (_sidebarRef$current2 = sidebarRef.current) === null || _sidebarRef$current2 === void 0 ? void 0 : _sidebarRef$current2.querySelector('.caret');
      (_sidebarRef$current3 = sidebarRef.current) === null || _sidebarRef$current3 === void 0 ? void 0 : _sidebarRef$current3.classList.remove('open');
      caret === null || caret === void 0 ? void 0 : caret.classList.remove('close');
    }
  }

  function togglePinnedSidebar() {
    setLSPinnedSidebar(lsPinnedSidebar === 'closed' ? 'pinned' : 'closed');
  }

  const noTenant = isEmpty(tenant);
  const noTenants = isEmpty(tenants);
  const isSidebarPinned = lsPinnedSidebar === 'pinned';
  return /*#__PURE__*/React.createElement(_StyledWrapper, {
    _css: screen.xlg,
    _css2: isSidebarPinned && '250px'
  }, /*#__PURE__*/React.createElement(SideBar, {
    ref: sidebarRef,
    togglePinnedSidebar: togglePinnedSidebar,
    toggleSideBar: toggleSideBar,
    closeSideBar: closeSideBar,
    pinned: isSidebarPinned
  }), noTenant && noTenants && !isInviteToken && /*#__PURE__*/React.createElement(CompleteSignUp, null), /*#__PURE__*/React.createElement(Main, {
    className: "main-content"
  }, children));
}

export default Layout;